import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MailCheck } from "lucide-react";

const checkEmailSearchSchema = z.object({
  redirect: z.string().optional(),
});

function CheckEmailPage() {
  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-surface-mute p-6">
      <div className="w-full max-w-md rounded-xl bg-surface p-10 shadow-sm border border-line text-center">
        <div className="flex justify-center mb-6">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-indigo-50">
            <MailCheck className="h-8 w-8 text-indigo-600" />
          </div>
        </div>
        <h1 className="text-2xl font-extrabold tracking-tight text-ink mb-3">
          Check your email
        </h1>
        <p className="text-ink-3 text-[15px] mb-6">
          We've sent a verification link to your inbox. Click it to activate your account.
        </p>
        <p className="text-sm text-ink-4">
          Didn't receive it?{" "}
          <a
            href="/resend-verification"
            className="font-semibold text-indigo-600 hover:text-indigo-500"
          >
            Send a new one
          </a>
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute("/(auth)/check-email")({
  validateSearch: checkEmailSearchSchema,
  component: CheckEmailPage,
  staticData: { authorize: false },
});
